<template>
	<div ref="element">
		<div class="simplebar-wrapper">
			<div class="simplebar-height-auto-observer-wrapper">
				<div class="simplebar-height-auto-observer" />
			</div>
			<div class="simplebar-mask">
				<div class="simplebar-offset">
					<div ref="scrollElement" class="simplebar-content-wrapper">
						<div ref="contentElement" class="simplebar-content">
							<slot />
						</div>
					</div>
				</div>
			</div>
			<div class="simplebar-placeholder" />
		</div>
		<div class="simplebar-track simplebar-horizontal">
			<div class="simplebar-scrollbar" />
		</div>
		<div class="simplebar-track simplebar-vertical">
			<div class="simplebar-scrollbar" />
		</div>
	</div>
</template>

<script>
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-unsafe-assignment */
	/* eslint-disable vue/no-unused-properties */
	import SimpleBar from 'simplebar'
	import { defineComponent } from 'vue'

	export default defineComponent({
		name: 'SimplebarVue',
		computed: {
			scrollElement() {
				return this.$refs.scrollElement
			},
			contentElement() {
				return this.$refs.contentElement
			},
		},
		mounted() {
			const options = SimpleBar.getOptions(this.$refs.element.attributes)
			this.SimpleBar = new SimpleBar(this.$refs.element, options)
		},
	})
</script>

<style src="simplebar/dist/simplebar.min.css"></style>
